import { Component, EventEmitter, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { AbstractControl, FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { NotificationService } from 'src/app/services/notifications.service';
import { ToastrService } from "ngx-toastr";
import Swal from 'sweetalert2';
import { ResponsiveService } from '../../responsive/responsive.service';
import { postServiceWorkerMessage } from 'src/serviceworker/message';
import { WorkerMessageType, WorkerUrlPrefetch } from 'src/serviceworker/service/events/message';
import { SharedService } from './../../services/sharedService/shared-service.service';
import { CommonPatternsService } from 'src/app/common-patterns.service';
import { LoggerService } from 'src/app/services/logger.service';
import { Store } from '@ngrx/store';
import { Observable, startWith, Subject, takeUntil } from 'rxjs';
import { selectAdvisorData } from 'src/app/state/selectors/advisors.selector';
import { selectLanguageData } from 'src/app/state/selectors';
import { loadLanguageData } from 'src/app/state/actions';
import { loadAdvisorData, loadAdvisorDataSuccess } from 'src/app/state/actions/advisors.actions';
import { loadMemberDataSuccess } from 'src/app/state/actions/members.actions';
import { loadCorporateDataSuccess } from 'src/app/state/actions/corporates.actions';
import { IdleService } from 'src/app/services/idle.service';
declare var $: any;
@Component({
  selector: 'app-pages-login',
  templateUrl: './pages-login.component.html',
  styleUrls: ['./pages-login.component.css'],
  // encapsulation: ViewEncapsulation.None
})
export class PagesLoginComponent implements OnInit {
  signinResults: any;


  loginform: FormGroup = new FormGroup({
    username: new FormControl(''),
    password: new FormControl('')
  });
  forgotform: FormGroup = new FormGroup({
    email: new FormControl(''),

  });
  activation: FormGroup = new FormGroup({
    activationcode: new FormControl('')
  });
  submitted = false;
  logo: any;
  showPassword: string = 'password';
  fafaEye: string = 'fa fa-eye-slash';
  version: string;
  public lang: any = {};
  selectedLanguage: string;
  languageData: any;
  languageData$: Observable<any>;
  private destroy$ = new Subject<void>();
  dashboardUrls:any= [];

  constructor(
    private logger: LoggerService,
    private SharedService: SharedService,
    private formBuilder: FormBuilder,
    private http: HttpClient,
    private router: Router,
    private notifyService: NotificationService,
    private toastrService: ToastrService,
    private commonPatternsService: CommonPatternsService,
    private idleService:IdleService,
    private store: Store<{ languageData: [], memberData: [], }>
  ) {
    this.languageData$ = store.select(selectLanguageData);
  }

  ngOnInit(): void {
    this.getLanguageTokens()
    // sessionStorage.clear()

    this.store.dispatch(loadMemberDataSuccess({ memberData: [] }))
    this.store.dispatch(loadCorporateDataSuccess({ corporateData: [] }))
    this.store.dispatch(loadAdvisorDataSuccess({ advisorData: [] }))

    this.logo = environment.loginPageLogo;
    this.version = environment.version;
    //Form Building for loginForm
    this.loginform = this.formBuilder.group(
      {

        username: [
          '',
          [
            Validators.required,
            Validators.pattern(this.commonPatternsService.emailPattern),
          ],
        ],
        password: [
          '',
          [
            Validators.required,
            Validators.minLength(8),
            Validators.maxLength(40),
          ],
        ],

      }
    );


    //Form Building for ForgotPassword
    this.forgotform = this.formBuilder.group(
      {

        email: [
          '',
          [
            Validators.required,
            Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$'),
          ],
        ],


      }
    );

    //Form Building for activationCode
    this.activation = this.formBuilder.group(
      {

        activationcode: [
          '',
          [
            Validators.required],
        ],


      }
    );
  }

  public getLanguageTokens() {
    this.store.dispatch(loadLanguageData());

    this.languageData$ = this.store.select(state => state.languageData).pipe(
      startWith([]),
      takeUntil(this.destroy$)
    );

    this.languageData$.subscribe(data => {
      if (data) {
        // console.log(data)
        if (data?.languageData == undefined || Object.keys(data.languageData).length <= 0) {
          console.log('No data to process', new Date().toISOString());
          return;
        }
        // if(Object.keys(this.lang).length>0){
        //   return;
        // }
        setTimeout(() => {
          this.lang = {};
          this.languageData = data?.languageData
          this.selectedLanguage = sessionStorage.getItem("language")
          for (let token of data?.languageData) {
            this.lang[token.key] = token[this.selectedLanguage];
          }
          // console.log('this.lang',this.lang)
        }, 0)
      }
    })
  }

  togglePasswordVisibility() {
    this.showPassword = (this.showPassword === "password") ? "text" : "password";
    this.fafaEye = (this.fafaEye === "fa fa-eye-slash") ? "fa fa-eye" : "fa fa-eye-slash";
  }

  get f(): { [key: string]: AbstractControl } {
    return this.loginform.controls;
  }

  get forgot(): { [key: string]: AbstractControl } {
    return this.forgotform.controls;
  }
  get activate(): { [key: string]: AbstractControl } {
    return this.activation.controls;
  }

  // async getLangTokens() {

  //   let accessToken = sessionStorage.getItem('accessToken');
  //   let customerDataEndpoint = environment.apiUrl + '/api/ap' + '/customer/formConfig';

  //   try {
  //     const response: any = await fetch("" + customerDataEndpoint, {
  //       method: 'GET',
  //       headers: {
  //         'Content-Type': 'application/json',
  //         'Authorization': `Bearer ${accessToken}`,
  //         'Lang': 'en'
  //       },

  //     });

  //     if (!response.ok) {
  //       let error = await response.json()
  //       console.log(error)
  //       throw new Error(error.error.message || error.error);
  //     }
  //     const { data } = await response.json();
  //     this.SharedService.setLangToken(data?.default_language_details?.languageTokens)

  //     return data;
  //   } catch (error) {
  //     Swal.fire({
  //       title: 'Error',
  //       text: error,
  //       showDenyButton: false,
  //       showCancelButton: false,
  //       confirmButtonText: 'Proceed',
  //     }).then(async (result) => {
  //       if (result.isConfirmed) {
  //         sessionStorage.clear()
  //       }
  //       else {
  //         sessionStorage.clear();
  //       }
  //     });

  //   }
  // }

  onSubmit(): void {

    this.submitted = true;
    if (this.loginform.invalid) {
      this.toastrService.error("Please Enter email and Password", 'Error');
      return;
    }

    // this.logger.log(JSON.stringify(this.loginform.value, null, 2));




    var endPoint = "/api/ap/auth/signin";
    var loginPostRequestBody = {
      "email": this.loginform.value.username.trim(),
      "password": this.loginform.value.password.trim()
    }

    //Testing
    // this.logger.log("Request: ", loginPostRequestBody);



    this.http.post(environment.apiUrl + endPoint, loginPostRequestBody).subscribe((response: any) => {



      if (response?.status == 200 || response?.statusCode == 200) {


        this.signinResults = response.data


        this.logger.log(this.signinResults)
        sessionStorage.setItem("signinResults", JSON.stringify(response.data));

        sessionStorage.setItem("accessToken", response["token"]);
        sessionStorage.setItem("loginname", this.loginform.value.username);
        sessionStorage.setItem("adminName", response.data.userName);
        sessionStorage.setItem("role", response.data.role);
        if(response.data.role == 'BROKER'){
          this.dashboardUrls = response.data?.dashboardUrls??[];
        }
        if(response.data.role=='ADMINISTRATOR'){
          this.dashboardUrls = response.data?.dashboardUrls ?? []
          if(this.dashboardUrls.length == 0) {
            this.dashboardUrls.push({
              name:'GroupBenefitz Monthly KPIs',
              url:'https://app.powerbi.com/view?r=eyJrIjoiNDQ1MTljYjktMWQxOS00MjFkLTk5YjYtYjUyNTk2OGE5OGFhIiwidCI6Ijg1ZDczZjgwLTQ5NzMtNGRmYy1iYWU4LTQ4ODI3MjQ2ZDM0ZiJ9'
            });
          }
          this.dashboardUrls = this.dashboardUrls.map((dashboard)=>{
            if(dashboard.url==''){
              return {
                ...dashboard,
                name:'GroupBenefitz Monthly KPIs',
                url:'https://app.powerbi.com/view?r=eyJrIjoiNDQ1MTljYjktMWQxOS00MjFkLTk5YjYtYjUyNTk2OGE5OGFhIiwidCI6Ijg1ZDczZjgwLTQ5NzMtNGRmYy1iYWU4LTQ4ODI3MjQ2ZDM0ZiJ9'
              }
            }else{
              return {...dashboard};
            }
          })
        }
        sessionStorage.setItem('dashboardUrls',JSON.stringify(this.dashboardUrls??[]));
        sessionStorage.setItem("language", "English");
        if (response && response.settings && response.settings.length > 0) {
          sessionStorage.setItem("fileSize", response.settings[0].settingsValue);
        }
        // await this.getLangTokens()


        var corporateId = sessionStorage.getItem('corporateId');
        var accessToken = sessionStorage.getItem('accessToken');
        var getClients = '/api/ap/admin/corporate/details/false';
        var getAdvisors = '/api/ap/brokers/details';
        var getMembers = '/api/ap/admin/customers/list';

        let prefetchurls = []

        let Data = [{
          url: environment.apiUrl + getClients,
          // fetch options
          options: {

            mode: 'cors',
            headers: {

              Authorization: 'Bearer ' + sessionStorage.getItem('accessToken'),
              'Content-Type': 'application/json',
            }
          }
        },
        {
          url: environment.apiUrl + getAdvisors,
          // fetch options
          options: {

            mode: 'cors',
            headers: {

              Authorization: 'Bearer ' + sessionStorage.getItem('accessToken'),
              'Content-Type': 'application/json',
            }
          }
        },
        {
          url: environment.apiUrl + getMembers,
          // fetch options
          options: {

            mode: 'cors',
            headers: {

              Authorization: 'Bearer ' + sessionStorage.getItem('accessToken'),
              'Content-Type': 'application/json',
            }
          }
        }]
        prefetchurls = Data

        // postServiceWorkerMessage(WorkerMessageType.Prefetch, prefetchurls)

        // this.http
        // .get(environment.apiUrl + getClients, {
        //   headers: {
        //     Authorization: 'Bearer ' + accessToken,
        //     'Content-Type': 'application/json',
        //   },
        // })
        // .subscribe(
        //   (response: any) => {
        //     if (response['status'] == 200 || response['statusCode'] == 200) {
        // // this._SharedService.setCorpData(response.data)

        //     }
        //   })

        this.http.get(environment.apiUrl + '/api/ap/global/set-adminMembers').subscribe((response) => { })
        this.http.get(environment.apiUrl + '/api/ap/global/set-adminCorporates').subscribe((response) => { })
        this.http.get(environment.apiUrl + '/api/ap/global/set-adminAdvisors').subscribe((response) => { })

        // let loginAgain = false;
        // this.http.post('http://[::1]:3002/api/ap/create-session',{
        //   role:response.data.role,
        //   portal:'Admin',
        //   sessionId:response["token"],
        // }).subscribe((response:any)=>{
        //   console.log(response)
        //   if(response.status === 200 || response.status === '200'){
        //     setTimeout(() => {
        //       this.router.navigate(['/dashboard']);
        //       this.idleService.startMonitoring();
        //     }, 1000);
        //   }else if(response.status === 201 || response.status === '201'){
        //     loginAgain = true;
        //     Swal.fire({
        //       title:"Logout from active session",
        //       text:response.message,
        //       cancelButtonText:'No',
        //       showCancelButton:true,
        //       confirmButtonText:'Yes',
        //       allowEscapeKey:false,
        //       allowOutsideClick:false
        //     }).then((result:any)=>{
        //       if(result.isConfirmed){
        //         this.http.post('http://[::1]:3002/api/ap/delete-session',{
        //           sessionId:accessToken,
        //           action:'Session Timeout'
        //         }).subscribe((response:any)=>{
        //           console.log(response)
        //           if(response.status === 200 || response.status === "200"){
        //             this.onSubmit();
        //           }else{
        //             Swal.fire({title:'Error',text:response.message})
        //             // sessionStorage.clear()
        //           }
        //         })
        //       }else{
        //         this.router.navigate(['/login']);
        //       }
        //     })
        //   }else{
        //     Swal.fire({
        //       title:"Error",
        //       text:response.message
        //     })
        //     this.router.navigate(['/login'])
        //   }
        // })

        // if( loginAgain == false ){
          setTimeout(() => {
            this.router.navigate(['/dashboard']);
            // this.idleService.startMonitoring();
          }, 1000);
        // }




      }
      else if (response?.status == 206 || response?.statusCode == 206) {
        $("#activationlink").show()

        // Swal.fire({title:'Alert',text:"Please Contact System admin"})
        // $("#activationlink").show()
      }
      else if (response?.status == 400 || response?.statusCode == 400) {
        // alert("Invalid Details")
        // this.toastrService.error('Invalid Credentials', 'Error!');
        Swal.fire({ title: 'Error', text: response.message })
        this.toastrService.error("Invalid Credentials", 'Error');
      }
      else {
        // alert("Invalid Details")
        // this.toastrService.error("Invalid Credentials", 'Error!');
        Swal.fire({ title: 'Error', text: response?.message??'Invalid Credentials' })
        this.toastrService.error("Unable to Login. Please try again", 'Error');
      }
    }, (error) => {
      Swal.fire({ title: 'Error', text: "Invalid Credentials" })
      // this.toastrService.error("Invalid Credentials", 'Error!');
      this.toastrService.error("Trouble Logging In. Please try again", 'Error');
    });
  }



  onReset(): void {

    this.loginform.reset();
  }

  forgotpassword() {

    this.forgotform.reset()
    $("#forgotpassword").show()

  }

  closeForgotmodel() {
    $("#forgotpassword").hide()
    this.forgotform.reset()
  }
  closeActivationCode() {
    $("#activationlink").hide()
    this.activation.reset()

  }
  SubmitforgotPassword() {

    var endPoint = "/api/ap/auth/forgotPassword/v2";
    let obj = {
      "email": this.forgotform.value.email
    }
    this.http.post(environment.apiUrl + endPoint, obj).subscribe((response: any) => {

      if (response["statusCode"] == 200 || response["status"] == 200) {
        Swal.fire({ title: 'Success', text: response.message })
        $("#forgotpassword").hide()
        this.forgotform.reset()
      }
      else if (response["statusCode"] == 400 || response["status"] == 400) {

        Swal.fire({ title: 'Error', text: response.message })
      }
      else {

        Swal.fire({ title: 'Error', text: response.message })
      }
    }, (error) => {
      Swal.fire({ title: 'Error', text: error.error.error.message })
    });
  }
  SubmitactivationCode() {

    var endPoint = '/api/ap/auth/userActivation/' + this.activation.value.activationcode + '';

    this.http.get(environment.apiUrl + endPoint,).subscribe((response: any) => {

      //modal alert
      // this.appComponent.modalAlert(response["message"]);

      if (response["statusCode"] == 200 || response["status"] == 200) {
        $("#activationlink").hide()
        // Swal.fire(response.message)

        Swal.fire({
          title: 'Info',
          text: response.message,
          showDenyButton: false,
          showCancelButton: false,
          confirmButtonText: 'Ok',

        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            this.onSubmit()
          }
        })




      }
      else if (response["statusCode"] == 400 || response["status"] == 400) {

        // alert("Invalid Details")
        // this.toastrService.error('Invalid Credentials', 'Error!');
        Swal.fire({ title: 'Error', text: response.message })
      }
      else {
        Swal.fire({ title: 'Error', text: response.message })
      }
    }, (error) => {
      Swal.fire({ title: 'Error', text: error.error.error.message })
    });
  }
}



